<template>
  <div class="step_companyType" v-loading="loading">
    <div>
      <p class="descript1">{{ $t('message.register.validateBusiness.companyOwner.descript1') }}</p>
      <p class="descript2">{{ $t('message.register.validateBusiness.companyOwner.descript2') }}</p>
    </div>
    <el-form :model="form" ref="form" class="form" :rules="rules">
      <div v-for="(businessOwner, index) in form.businessOwners" :key="index" class="approver">
        <div class="item">
          <el-form-item class="firstName" :prop="'businessOwners.' + index + '.firstName'" required>
            <el-input v-model="businessOwner.firstName"
              :placeholder="$t('message.register.companyRepresentative_desc.legalName_firstName')"
              :disabled="isDisabled" />
          </el-form-item>

          <el-form-item class="lastName" :prop="'businessOwners.' + index + '.lastName'" required>
            <el-input v-model="businessOwner.lastName"
              :placeholder="$t('message.register.companyRepresentative_desc.legalName_lastName')"
              :disabled="isDisabled" />
          </el-form-item>

          <el-form-item class="emailAddress" :prop="'businessOwners.' + index + '.emailAddress'">
            <el-input v-model="businessOwner.emailAddress" placeholder="person@company.com" :disabled="isDisabled" />
          </el-form-item>

          <el-button plain class="delete_btn" @click="removeBusinessOwner(index)"
            :disabled="isDisabled || form.businessOwners.length === 1">
            {{ $t('message.tableCommon.delete') }}
          </el-button>
        </div>
      </div>

      <el-button class="add_btn" plain @click="addBusinessOwner" :disabled="isDisabled">{{ $t('message.register.addAll')
      }}</el-button>
    </el-form>

    <div class="button-box">
      <el-button type="primary" @click="confirm" size="mini" :disabled="isDisabled">{{ $t('message.exchange.continue')
      }}</el-button>
    </div>
  </div>
</template>

<script>

import mixins from '../../mixins';
export default {
  name: 'StepCompanyOwner',
  mixins: [mixins],
  data() {
    return {
      rules: {
        // 动态规则，校验每个所有人的 firstName、lastName 和 emailAddress
        'businessOwners.*.firstName': [
          { required: true, message: this.$t('message.validator.required'), trigger: 'blur' },
        ],
        'businessOwners.*.lastName': [
          { required: true, message: this.$t('message.validator.required'), trigger: 'blur' },
        ],

      },
      form: {
        businessOwners: [
          { firstName: '', lastName: '', emailAddress: '' }, // 默认有一个审批人
        ],
      },
    };
  },
  methods: {
    addBusinessOwner() {
      this.form.businessOwners.push({ firstName: '', lastName: '', emailAddress: '' });
    },
    removeBusinessOwner(index) {
      this.form.businessOwners.splice(index, 1);
    },
    confirm() {
      // 触发表单校验
      this.$refs.form.validate((valid) => {
        if (valid) {
          const businessOwners = this.form.businessOwners;
          const data = businessOwners.map(item => {
            return {
              legalName: {
                firstName: item.firstName,
                lastName: item.lastName,
              },
              emailAddress: item.emailAddress,
            };
          });
          this.$emit('updateFormData', { businessOwners: data, currentStep: 'businessOwners', nextStep: 'websiteOrAppDetails' });
        }
      });
    },
  },
  watch: {
    applicationInfo: {
      handler(applicationInfo) {
        const { businessOwners, currentStep } = applicationInfo;
        if (Array.isArray(businessOwners)) {
          if (businessOwners.length === 0) {
            this.form.businessOwners = [{ firstName: '', lastName: '', emailAddress: '' }];
            this.$emit('onlyUpdateForm', { businessOwners: [{ firstName: '', lastName: '', emailAddress: '' }], currentStep: 'businessOwners' });
          } else {
            this.form.businessOwners = businessOwners.map(item => {
              return {
                firstName: item.legalName.firstName,
                lastName: item.legalName.lastName,
                emailAddress: item.emailAddress,
              };
            });
            this.$emit('onlyUpdateForm', { businessOwners, currentStep: 'businessOwners' });
          }
        } else {
          const { businessOwners: { legalName, emailAddress } } = applicationInfo;
          const _data = { emailAddress, ...legalName };
          this.$emit('onlyUpdateForm', { businessOwners: [_data], currentStep: 'businessOwners' });
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .approver {
    .el-form-item__error {
      display: none;
    }
  }

}

.button-box {
  width: 100%;

  .el-button {
    width: 100% !important;
  }
}

.form {
  .item {
    display: flex;

    .firstName,
    .lastName {
      flex-basis: 150px;
    }

    .delete_btn {
      display: flex;
      height: 44px;
      margin-left: 6px;
    }
  }

  .add_btn {
    display: flex;
    width: 100%;
    margin: -15px 0 64px;
    text-align: center;
  }
}
</style>
